import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Dialog, DialogContent, DialogTitle, Box, Grid } from '@mui/material';
import DashboardCards from '../../Components/DashboardCards';
import LargePostCardDialog from '../../Components/LargePostCardDialog';
import { useAuth } from '../../contexts/AuthContext';

const MyPosts = () => {
  const { posts, setPosts } = useOutletContext();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isEditable, setIsEditable] = useState(false); // Track edit mode
  const { deleteUserPost, updateUserPost, updatePost } = useAuth(); // Get deleteUserPost from AuthContext

  //Function to handle SummaryCard click and display LargePostDialog popUp
  const handleCardClick = (cardData) => {
    if (!cardData) {
      console.error('Card data is not available');
      return;
    }
    setSelectedCard(cardData); // cardData now contains category too so above code not needed
    setIsEditable(false); // Enable edit mode
    setOpenDialog(true);
  };

  // Handle Edit Click
  const handleEditClick = (cardData) => {
    if (!cardData) {
      console.error("Card data is not available");
      return;
    }
    setSelectedCard(cardData);
    setIsEditable(true); // Enable edit mode
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCard(null);
  };

  const handlePostDelete = (deletedPostId) => {
    setPosts((prevPosts) =>
      prevPosts.filter((post) => post.id !== deletedPostId)
    );
    deleteUserPost(deletedPostId); // Call deleteUserPost to update userPosts in AuthContext
  };

  // Handle Post Save
  const handlePostSave = (updatedPost) => {
    setPosts((prevPosts) =>
      prevPosts.map((post) => (post.id === updatedPost.id ? updatedPost : post))
    );
    updateUserPost(updatedPost.id, updatedPost); // Save changes to Firebase
    handleCloseDialog(); // Close the dialog after save
  };

  return (
    <Box
      sx={{
        pt: 0,
        pl: 0,
      }}
    >
      <Box
        sx={{
          gap: 3,
          mt: 1,
          mb: 5,
          p: 1,
          pb: 3,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
      >
        {/* <Grid container spacing={1}> */}
        {posts.map((post) => (
          <DashboardCards
            key={post.id} // Added key to each DashboardCards component
            // postData={post}
            id={post.userId}
            postID={post.id}
            images={post.images || []} // Pass the entire array of images
            title={post.title}
            summary={post.description}
            photoURL={post.userPhotoURL}
            username={post.username} //pass the username to LargePostCard
            name={post.name}
            email={post.email}
            location={post.location || null}
            date={post.readableDate}
            category={post.category}
            postsCount={post.length}
            vertical='230px'
            horizontal={'300px'}
            deletable={true}
            onClick={() => handleCardClick(post)}
            onEditClick={() => handleEditClick(post)} // Pass Edit Post handler
            onDelete={() => handlePostDelete(post.id)} // Pass handlePostDelete to DashboardCards
          />
        ))}
        {/* </Grid> */}
      </Box>
      {/* PopUp Dialog displaying LargePostCardDialog */}
      {selectedCard && (
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth='lg'
          fullWidth
          PaperProps={{
            style: {
              maxHeight: 'calc(100vh - 15px)',
              overflowY: 'auto',
              height: '85vh',
              borderRadius: '24px',
            },
          }}
        >
          <DialogTitle sx={{ mb: 1, p: 2 }}>
            {/* {selectedCard.title} */}
            <IconButton
              aria-label='close'
              onClick={handleCloseDialog}
              sx={{
                position: 'absolute',
                right: { xs: 2, sm: 2, md: 4, lg: 8, xl: 8 },
                top: { xs: 1, sm: 1, md: 3, lg: 8, xl: 8 },
                color: (theme) => theme.palette.grey[500],
                '&:hover': {
                  backgroundColor: 'indianred',
                  color: 'white',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              mt: 0,
              mb: 0,
              p: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <LargePostCardDialog
              id={selectedCard.userId}
              postID={selectedCard.id}
              images={selectedCard.images}
              title={selectedCard.title}
              summary={selectedCard.description}
              link={selectedCard.link}
              ratings={selectedCard.ratings}
              postInfo={selectedCard} // Pass the whole object
              photoURL={selectedCard.userPhotoURL}
              username={selectedCard.username} //pass the username to LargePostCard
              name={selectedCard.name}
              email={selectedCard.email}
              location={selectedCard.location || null}
              date={selectedCard.readableDate}
              category={selectedCard.category}
              isEditable={isEditable} // Pass edit mode flag
              cardData={selectedCard} // Pass selected card data
              onClose={handleCloseDialog} // Pass close handler
              // onSave={(updatedData) => {
              //   // Save edited data to Firebase
              //   updateUserPost(selectedCard.id, updatedData);
              //   handleCloseDialog(); // Close the dialog after save
              // }}
              onSave={handlePostSave} // Update post when saved
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default MyPosts;
